import api from '../../fetch/api'
import * as types from '../types'

const state = {
  typeList: []
}

const actions = {
  getTypeList ({commit}) {
    api.getGroup('mapgrouptype').then(res => {
      commit(types.TYPE_LIST, res)
    })
  }
}

const getters = {
  getTypeList: state => state.typeList
}

const mutations = {
  [types.TYPE_LIST] (state, res) {
    for (let i = 0; i < res.length; i++) {
      if (res[i].count < 16) {
        continue
      }
      state.typeList.push(res[i])
    }
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/module/type.js